import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from './shared/libs/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  readonly #authService = inject(AuthService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #router = inject(Router);

  constructor() {
    this.check();
  }

  check(): void {
    this.#authService.getUserLogged
    .pipe(takeUntilDestroyed(this.#destroyRef))
    .subscribe((user) => {
      if(user?.Roles) this.#router.navigate(['/user/company-selection']);
    });
  }
}
